export const PURCHASE_MAX_SAFE=Number.MAX_SAFE_INTEGER;

export function parsePurchaseMargin(value) {
  const text=String(value??'').trim();
  if(!text)return null;
  if(!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(text)||!Number.isFinite(Number(text))||Number(text)>95)throw Error('Enter a purchase margin between 0 and 95, or leave blank for the customer tier.');
  return Number(text);
}
export function validatePurchaseCommercial(purchase,laser=false) {
  if(!purchase)return;
  if(purchase.margin_pct!=null&&(!Number.isFinite(purchase.margin_pct)||purchase.margin_pct<0||purchase.margin_pct>95))throw Error('Review the purchase margin (0 to 95).');
  for(const row of purchase.price_breaks||[])if(row.sell_override_micros!=null&&(!Number.isSafeInteger(row.sell_override_micros)||row.sell_override_micros<0))throw Error('Review sell overrides: amounts must use the safe six-decimal range.');
}
export function parsePurchaseMicros(value) {
  const text=String(value).trim();
  if(!/^\d+(?:\.\d{0,6})?$/.test(text))throw Error('Enter a nonnegative amount with up to six decimal places.');
  const [whole,fraction='']=text.split('.');
  const micros=Number(BigInt(whole)*1000000n+BigInt(fraction.padEnd(6,'0')));
  if(!Number.isSafeInteger(micros)||micros<0)throw Error('Purchase amount is outside the safe range.');
  return micros;
}
export function formatPurchaseMicros(value) {
  const text=String(value).padStart(7,'0');
  return `${text.slice(0,-6)}.${text.slice(-6)}`.replace(/0+$/,'').replace(/\.$/,'');
}
export function selectedPurchaseBreak(purchase,quantity) {
  const rows=new Map();
  for(const row of purchase?.price_breaks||[])rows.set(row.from_quantity,row);
  const sorted=[...rows.values()].sort((a,b)=>a.from_quantity-b.from_quantity);
  return sorted.filter(row=>row.from_quantity<=quantity).pop()||sorted[0]||null;
}
export function purchaseBreakPreview(purchase,quantity) {
  validatePurchaseCommercial(purchase);
  const breaks=purchase?.price_breaks||[];
  if(!breaks.length)return null;
  if(breaks.length>100||!Number.isInteger(quantity)||quantity<1||quantity>1000000||breaks.some(row=>!Number.isInteger(row.from_quantity)||row.from_quantity<1||row.from_quantity>1000000||!Number.isSafeInteger(row.unit_cost_micros)||row.unit_cost_micros<0))throw Error('Review the supplier break quantities and amounts.');
  const selected=selectedPurchaseBreak(purchase,quantity),product=selected.unit_cost_micros/1000000*quantity;
  if(!Number.isFinite(product)||product>=1e21)throw Error('Purchase buy cost is outside the safe range.');
  const total=product.toFixed(2);
  if(BigInt(total.replace('.',''))>BigInt(PURCHASE_MAX_SAFE))throw Error('Purchase buy cost exceeds the safe integer-cent range.');
  if(selected.sell_override_micros>0){
    const sellProduct=selected.sell_override_micros/1000000*quantity;
    if(!Number.isFinite(sellProduct)||sellProduct>=1e21||BigInt(sellProduct.toFixed(2).replace('.',''))>BigInt(PURCHASE_MAX_SAFE))throw Error('Purchase sell override exceeds the safe integer-cent range.');
  }
  return {selected,total};
}
